/* eslint-disable camelcase */
export default {
  tab_main: "Main",
  tab_email: "E-mail",
  tab_phone: "Phone",
  tab_password: "Password",
  unknown_error: "Unexpected error occured while editing proile",
};
